import { render, staticRenderFns } from "./ChatDistributions.vue?vue&type=template&id=49a89b90&scoped=true"
import script from "./ChatDistributions.vue?vue&type=script&lang=js"
export * from "./ChatDistributions.vue?vue&type=script&lang=js"
import style0 from "./ChatDistributions.vue?vue&type=style&index=0&id=49a89b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a89b90",
  null
  
)

export default component.exports